import $ from 'jquery';
import { isWindow } from 'stdjs/utilities';
import { head } from 'underscore';

export function initDataTableResizerFunction(dataTable, $resizeContainer, $boundingContainer, options = {}, $bottomContainer = null ){
                
    var options = $.extend({
        extraWidthModifier: 0,                
        isChildTable: false,
        boundingTable: false,
        childTableStartingHeight: null
    }, options);
    
    /**
     * Set up a resize function for the table
     */
    var resizeFunction = function(){

        /**
         * Calculate the new container height
         */
        var newHeight = calcNewContainerHeight( $boundingContainer, $resizeContainer );
        
        /**
         * Calculate the new container width
         */
        var newWidth = calcNewContainerWidth( $boundingContainer, $resizeContainer, options.extraWidthModifier, options.isChildTable, options.boundingTable );   
        
        if (options.isChildTable){

            if( options.childTableStartingHeight != null && $boundingContainer != null ){   
                $boundingContainer.css({
                    "max-height": options.childTableStartingHeight + 1, // +1 to fix table scrolling
                    "min-height": options.childTableStartingHeight + 1, // +1 to fix table scrolling
                    "height": options.childTableStartingHeight + 1, // +1 to fix table scrolling
                });
            }

            options.boundingTable.closest(".childTableSection").css({
                "min-width": newWidth, 
                "max-width": newWidth,  
                "width": newWidth
            });

            $(options.boundingTable).on("merisis-post-column-visibility", (function(e, settings, details){

                var $headerTable = $boundingContainer.closest(".dataTables_scroll").find(".dataTables_scrollHeadInner table");
                var headerWidth = $headerTable.width();

                $boundingContainer.css({
                    "max-width": headerWidth - 40, 
                    "min-width": headerWidth - 40, 
                    "width": headerWidth - 40,
                    "max-height": options.childTableStartingHeight + 1, // +1 to fix table scrolling
                    "min-height": options.childTableStartingHeight + 1, // +1 to fix table scrolling
                    "height": options.childTableStartingHeight + 1, // +1 to fix table scrolling
                });

                options.boundingTable.closest(".childTableSection").css({
                    "min-width": headerWidth, 
                    "max-width": headerWidth,  
                    "width": headerWidth
                });

                /**
                 * Now redraw the tables
                 */
                dataTable.draw();
                $(options.boundingTable).DataTable().draw();
            }));

        } else {

            /**
             * Resize the resize container to these dimensions
             */
            $resizeContainer.css({
                "max-height": newHeight, 
                "height": newHeight,
                "max-width": newWidth, 
                "width": newWidth
            });

            if( $bottomContainer != null ){
                $bottomContainer.css({
                    "max-width": newWidth, 
                    "width": newWidth
                });
            }
        }
        
        /**
         * Now (it was like this before, not sure why), set the
         * height of the resize container and its parent to 100%
         */
        $resizeContainer.height("100%");
        //$resizeContainer.parent().height("100%");
        
        /**
         * Now redraw the table
         */
        dataTable.draw();
        
    }
    
    /**
     * Now we have our function, set it up to run on window resize
     */
    $(window).resize(function(){        
        resizeFunction();
    });
    
        
    /**
     * And run it once now to get things going
     */         
    resizeFunction();
    
    /**
     * Return the function should anyone want to call it themselves.
     */
    return resizeFunction;
    
}

function getOffsetTopRelative( $element, $relativeTo ){
    if ( isWindow( $relativeTo[0] ) ){
        return $element.offset().top;
    }     
    
    return $element.offset().top - $relativeTo.offset().top;
}    
   
function getOffsetLeftRelative( $element, $relativeTo ){
    if ( isWindow( $relativeTo[0] ) ){
        return $element.offset().left;
    }  
    return $element.offset().left - $relativeTo.offset().left;
} 


function calcNewContainerHeight( $boundingContainer, $resizeContainer, bottomMargin = 0 ){
    
    /**
     * Get the height of the bounding container
     */
    var boundingContainerHeight = $boundingContainer.height()
    
    /**
     * Find the top of the resize container relative to the bounding container
     */
    var resizeContainerOffset = getOffsetTopRelative( $resizeContainer, $boundingContainer );
    
    /**
      * calc the new height
      */
    return boundingContainerHeight - resizeContainerOffset - bottomMargin;
}

function calcNewContainerWidth( $boundingContainer, $resizeContainer, extraWidthModifier, isChildTable, boundingTable ){

    /**
     * Get the width of the bounding container
     */
    var boundingContainerWidth = $boundingContainer.width();

    /**
     * Find the left of the resize container relative to the bounding container
     */
    var resizeContainerOffset = getOffsetLeftRelative( $resizeContainer, $boundingContainer );
    
    if (isChildTable && boundingTable.length > 0){         
        
        var columns = boundingTable.DataTable().settings().init().columns;        
        var width = 0;
        
        for (var column of columns) {

            if (!column.visible){
                continue;
            }

            var col = boundingTable.DataTable().column(column.name + ":name");
            width += $(col.header()).width() + 10;
        };

        boundingContainerWidth = width + 100;        
    }
    
    /**
     * calc the new width
     */
    return boundingContainerWidth - resizeContainerOffset - extraWidthModifier;
    
}

    